import { apiRoutes } from "../../config";
import { api } from "../../utils/lib/api";

export const getCronjobsStatus = async (params = {}) => {
  return (await api.get(`${apiRoutes.cronjob.status}`, {
    params: {
      page: params.page || 1,
      limit: params.limit || 10,
      name: params.name || undefined,
      status: params.status || "active",
    }
  })).data;
};
